import { render } from "./LeaderboardView.vue?vue&type=template&id=37983c1b&scoped=true"
import script from "./LeaderboardView.vue?vue&type=script&lang=js"
export * from "./LeaderboardView.vue?vue&type=script&lang=js"

import "./LeaderboardView.vue?vue&type=style&index=0&id=37983c1b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37983c1b"]])

export default __exports__